module.exports = __webpack_public_path__ + "img/icon-highcbd.1c6a71ec.svg";